<template>
  <div class="user">
    <div class="user-info">
      <span>
        {{ title }}
      </span>
</div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  components: {
    //CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    rtlTitle: {
      type: String,
      default: "تانيا أندرو",
    },
 },
  data() {
    return {
      isClosed: true,
    };
  },
  methods: {
    clicked: function (e) {
      e.preventDefault();
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed;
    },
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
